import React, { useEffect, useState, useContext } from 'react';
import Button from '@mui/material/Button';
import { motion } from 'framer-motion';
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import Menu from '../Menu';
import './local.css';

function Header() {
    const [viewMenu, setViewMenu] = useState(true)
    const { LNG, setLNG } = useContext(DefaultContext)
    const [scrolled, setScrolled] = useState(false);
    const btnDescription = [
        {
            name: LNG ? ptbr.menuAction.item_1 : eng.menuAction.item_1,
            id: 'salutation-container'
        },
        {
            name: LNG ? ptbr.menuAction.item_2 : eng.menuAction.item_2,
            id: 'about-container'
        },
        {
            name: LNG ? ptbr.menuAction.item_3 : eng.menuAction.item_3,
            id: 'skills-container'
        },
        {
            name: LNG ? ptbr.menuAction.item_4 : eng.menuAction.item_4,
            id: 'tecnologies-container'
        },
        {
            name: LNG ? ptbr.menuAction.item_5 : eng.menuAction.item_5,
            id: 'experience-container'
        },
    ];

    useEffect(() => {
        // if (window.innerWidth <= 1050) setViewMenu(false)
        const handleResize = () => {
            if (window.innerWidth <= 850) setViewMenu(false)
            else setViewMenu(true)
        };

        window.scrollTo({
            top: 0
        });

        const handleScroll = () => {
            const scrollTop = window.scrollY;
            console.log(scrollTop, '@@@');
            if (scrollTop > 20) setScrolled(true)
            else setScrolled(false);
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div
            className={scrolled
                ? "header-container off"
                : "header-container"
            }
        >
            {viewMenu
                ? <div style={Styles.headerMenu}>
                    {btnDescription.map((btn, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, scale: 0 }}
                            animate={{ opacity: 1, scale: 1.01 }}
                            transition={{
                                duration: 1,
                                delay: index / 2,
                                ease: [0, 0.91, 0.2, 1.01],
                                scale: {
                                    type: "spring",
                                    damping: 10,
                                    stiffness: 100,
                                    restDelta: 0.001
                                }
                            }}
                            exit={{ opacity: 0 }}
                        >
                            <Button
                                onClick={() => {
                                    const section = document.getElementById(btn.id);
                                    window.scrollTo({
                                        top: section?.offsetTop,
                                        behavior: 'smooth'
                                    });
                                }}
                                variant="text"
                                size='large'
                                style={{
                                    fontSize: '1.4rem !important',
                                }}
                            >
                                {btn.name}
                            </Button>
                        </motion.div>
                    ))}
                </div>
                : <Menu btnDescription={btnDescription} />
            }
            <div style={Styles.translateButton}>
                <Button
                    className={LNG ? "active-button" : 'disable-button'}
                    variant={LNG ? "contained" : 'outlined'}
                    style={{ marginRight: '0.5rem' }}
                    onClick={() => setLNG(!LNG)}
                >
                    BRL
                </Button>
                <Button
                    className={LNG ? 'disable-button' : 'active-button'}
                    variant={LNG ? "outlined" : 'contained'}
                    onClick={() => setLNG(!LNG)}
                >
                    ENG
                </Button>
            </div>
        </div>
    );
}

const mainContainer = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'start',
    padding: '0rem 15rem',
    top: 0,
    width: '100vw',
    height: '10vh',
    position: 'fixed',
    zIndex: 9999
}

const Styles = {
    mainContainer,
    mainContainerOffSet: {
        ...mainContainer,
        background: 'rgba(255, 255, 255, 0.2)',
        boxShadow: '0rem 0.4rem 3rem rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(0.5rem)',
        border: '0.1rem solid rgba(238, 255, 178, 0.3)',
    },
    headerMenu: {
        display: 'flex',
        width: '100%'
    },
    translateButton: {
        display: 'flex',
        height: '4rem',
        // width: '19rem',
        // right: '10rem'
    }
}

export default Header;